import React from 'react';
import { ApplicationView as view } from '@aha-app/mvc';
import SelectionContextMenu from './SelectionContextMenu';

const SelectionAppContainer = () => {
  return <SelectionContextMenu />;
};

export default view(SelectionAppContainer);
